import { useState } from "react";
import { MdClose } from "react-icons/md";

export const ExpireDaysDropdown = ({
  expireDays,
  setExpireDays,
}: {
  expireDays: any;
  setExpireDays: any;
}) => {
  const [dropdown, setDropdown] = useState(false);
  const [customExpiration, setCustomExpiration] = useState(false);

  const handleDropdown = () => {
    window.addEventListener("click", (w) => {
      if ((w.target as any)?.closest(".dropdown-toggle1")) {
        if (dropdown) {
          setDropdown(false);
        } else {
          setDropdown(true);
        }
      } else {
        setDropdown(false);
      }
    });
  };

  if (customExpiration) {
    return (
      <div className="flex items-center relative">
        <input
          type="number"
          className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
          placeholder="Amount"
          min={0}
          value={expireDays}
          // onChange={(e) => setAssetAmount(e.target.value)}
          onChange={(e) =>
            String(e.target.value).length < 6
              ? setExpireDays(e.target.value)
              : () => {}
          }
        />
        <button
          onClick={() => {
            setCustomExpiration(false);
            setExpireDays(1);
          }}
          className="absolute right-2 flex h-6 w-6 items-center justify-center rounded-md        bg-jacarta-500 shadow-jacarta-500 hover:bg-accent-dark text-center font-semibold text-white transition-all"
        >
          <MdClose size={16} />
        </button>
      </div>
    );
  }

  return (
    <>
      <div
        className={
          dropdown
            ? "overlay h-[100vh] dropdown-toggle w-[100vw] fixed top-0 left-0 opacity-0 show bg-red z-40 cursor-default"
            : "overlay h-[100vh] w-[100vw] fixed top-0 left-0 opacity-0 hidden bg-red z-30 cursor-default"
        }
        onClick={() => handleDropdown()}
      ></div>

      <div
        className="dark:bg-jacarta-700 dropdown-toggle1 border-jacarta-100 dark:border-jacarta-600 dark:text-jacarta-300 flex items-center justify-between rounded-lg border bg-white py-3 px-3 show z-10 relative"
        onClick={() => handleDropdown()}
      >
        {expireDays ? (
          <span className="">
            {expireDays} {expireDays == 1 ? "Day" : "Days"}
          </span>
        ) : (
          <span className="">Select Expiration</span>
        )}
      </div>
      <div
        className={
          dropdown
            ? "absolute dark:bg-jacarta-800 whitespace-nowrap w-full rounded-xl bg-white py-4 px-2 text-left shadow-xl show z-40"
            : "absolute dark:bg-jacarta-800 whitespace-nowrap w-full rounded-xl bg-white py-4 px-2 text-left shadow-xl hidden z-20"
        }
      >
        <ul className="scrollbar-custom flex max-h-48 flex-col overflow-y-auto">
          {[1, 3, 7, 30, "custom"].map((expiration: any, i) => {
            return (
              <li key={i + "expiration"}>
                <button
                  className="dropdown-item font-display dark:hover:bg-jacarta-600 hover:bg-jacarta-50 flex w-full items-center justify-between rounded-xl px-5 py-2 text-left text-sm transition-colors dark:text-white"
                  onClick={() => {
                    if (expiration === "custom") {
                      setCustomExpiration(true);
                    } else {
                      setExpireDays(expiration);
                    }
                  }}
                >
                  <span className="flex items-center space-x-3">
                    <span className="text-jacarta-700 dark:text-white">
                      {expiration}{" "}
                      {expiration !== "custom" &&
                        (expiration == 1 ? "Day" : "Days")}
                    </span>
                  </span>
                  {expireDays && expireDays === expiration && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      className="fill-accent mb-[3px] h-4 w-4"
                    >
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                    </svg>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};
